import * as React from "react";
import { SVGProps } from "react";

const Ticket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.857 3.125c-.07.195-.107.406-.107.625v.625h-.625A.625.625 0 0 0 2.5 5v1.982c0 .166.066.325.183.442L7.058 11.8c.244.244.64.244.884 0l.55-.549.182.183c.258.257.571.424.901.5l-.75.75a1.875 1.875 0 0 1-2.65 0L1.798 8.308a1.875 1.875 0 0 1-.549-1.326V5c0-1.036.84-1.875 1.875-1.875h.732Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3.75c0-.345.28-.625.625-.625h1.982c.166 0 .325.066.442.183l4.375 4.375a.625.625 0 0 1 0 .884l-1.982 1.982a.625.625 0 0 1-.884 0L5.183 6.174A.625.625 0 0 1 5 5.732V3.75Zm.625-1.875c-1.036 0-1.875.84-1.875 1.875v1.982c0 .498.198.974.55 1.326l4.374 4.375c.732.732 1.92.732 2.652 0l1.982-1.982a1.875 1.875 0 0 0 0-2.652L8.933 2.424a1.875 1.875 0 0 0-1.326-.549H5.625Zm1.25 3.75a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Z"
      fill="#fff"
    />
  </svg>
);

export default Ticket;
